import { render, staticRenderFns } from "./PagePlaces.vue?vue&type=template&id=98a76eac&"
import script from "./PagePlaces.vue?vue&type=script&lang=js&"
export * from "./PagePlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a76eac')) {
      api.createRecord('98a76eac', component.options)
    } else {
      api.reload('98a76eac', component.options)
    }
    module.hot.accept("./PagePlaces.vue?vue&type=template&id=98a76eac&", function () {
      api.rerender('98a76eac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/places/PagePlaces.vue"
export default component.exports